import { render } from "./TooltipContent.vue?vue&type=template&id=2050467b&scoped=true"
import script from "./TooltipContent.vue?vue&type=script&lang=js"
export * from "./TooltipContent.vue?vue&type=script&lang=js"

import "./TooltipContent.vue?vue&type=style&index=0&id=2050467b&scoped=true&lang=css"
import "./TooltipContent.vue?vue&type=style&index=1&id=2050467b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-2050467b"

export default script